var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppSheetWrapper',{staticClass:"sheet-unit-large"},[_c('AppSheetRow',[_c('AppSheetBlockTitleAndAvailability',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"availability-status":_vm.availabilityStatus,"availability-color":_vm.availabilityColor}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }